import i18n from "~/i18n";

export const columnsMapByType = {
  Time: i18n.t("Time"),
  Date: i18n.t("Date"),
  Label: i18n.t("Label"),
};
